<template>
    <div class="anamnes">
        <div class="fertil-girl">
            <div class="anamnes-with-by-effect" v-if="getHimResult === 'Не отримував хіміотерапію'">
                <plan-baby-by-effect v-if="getIsFertilGirl"/>
                
                <div class="older-fertil-girl" v-if="getIsOlderFertilGirl">
                    <hozl-3 v-if="randVal === 0"/>
                    <asma v-if="randVal === 1"/>
                    <ch-1-2 v-if="randVal === 2"/>
                    <radiation-therapy v-if="randVal === 3"/>
                    <covid v-if="randVal === 4" />
                    <plan-baby v-if="randVal === 5" />
                </div>
            </div>
            <div class="baby" v-if="(getPrimaryPetABVDKtResult === 'D5' || getPrimaryABVDKtResult === 'Прогресія')">
                <plan-baby />
            </div>            
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import PlanBaby from '../../../../components/Doctor/ByEffects/PlanBaby';
import PlanBabyByEffect from '../../../../components/Doctor/ByEffects/PlanBabyByEffect';

import RadiationTherapy from '../../../../components/Doctor/ByEffects/RadiationTherapy';
import Hozl3 from '../../../../components/Doctor/ByEffects/Hozl3';
// import Hozl4 from '../../../../components/Doctor/ByEffects/Hozl4';
import Ch12 from '../../../../components/Doctor/ByEffects/Ch1_2';
import Covid from '../../../../components/Doctor/ByEffects/Covid';
import Asma from '../../../../components/Doctor/ByEffects/Asma';

export default {
    components : {
        'plan-baby' : PlanBaby,
        'plan-baby-by-effect' : PlanBabyByEffect,

        'radiation-therapy' : RadiationTherapy,
        'hozl-3' : Hozl3,
        // 'hozl-4' : Hozl4,
        'ch-1-2' : Ch12,
        'covid' : Covid,
        'asma' : Asma,
    },
    data : () => ({
        randVal : null
    }),
    computed : {
        ...mapGetters([
            'getPrimaryPetABVDKtResult',
            'getPrimaryABVDKtResult',
            'getHimResult',
            
            'getIsFertilGirl',
            'getIsOlderFertilGirl',

            'getFertilAnamnezInPatientResultPage'
        ])
    },
    methods : {
        ...mapMutations([
            'setFertilAnamnesResult',
            'resetFertilAnamnes'
        ]),
        getRand(maxValue){
            if(maxValue === 2){
                return Math.random() < 0.5 ? 0 : 1;
            }
            else{
                return Math.floor(Math.random() * maxValue);
            }
        }
    },
    beforeCreate(){
        this.$nextTick(() => {
            this.resetFertilAnamnes();

            // if(this.getFertilAnamnezInPatientResultPage.length > 0){
            //     console.log(this.getFertilAnamnezInPatientResultPage[0]);
            //     switch(this.getFertilAnamnezInPatientResultPage[0]){
            //         case 'ХОЗЛ ІІІ ступеня (ОФВ 45%)':
            //             this.randVal = 0;
            //         break;
            //         case 'Бронхіальна астма середнього ступеня важкості':
            //             this.randVal = 1;
            //         break;
            //         case 'СН I-II ступеня, куріння':
            //             this.randVal = 2;
            //         break;
            //         case 'Променева терапія грудної клітки в минулому':
            //             this.randVal = 3;
            //         break;
            //         case 'COVID пневмонія перенесена 1 місяць тому':
            //             this.randVal = 4;
            //         break;
            //         case 'Пацієнтка планує народити дитину після терапії':
            //             this.randVal = 5;
            //         break;
            //     }
            // }
            // else{
                this.randVal = this.getRand(6);
                console.log('%cRand val: ' + this.randVal, 'color: red;');
            // }

            if(this.getHimResult === 'Не отримував хіміотерапію'){
                if(this.getIsOlderFertilGirl){
                    switch(this.randVal){
                        case 0: {
                            this.setFertilAnamnesResult('ХОЗЛ ІІІ ступеня (ОФВ 45%)');
                        }
                        break;
                        case 1: {
                            this.setFertilAnamnesResult('Бронхіальна астма середнього ступеня важкості');
                        }
                        break;
                        case 2: {
                            this.setFertilAnamnesResult('СН I-II ступеня, куріння');
                        }
                        break;
                        case 3:{
                            this.setFertilAnamnesResult('Променева терапія грудної клітки в минулому');
                        }
                        break;
                        case 4:{
                            this.setFertilAnamnesResult('COVID пневмонія перенесена 1 місяць тому');
                        }
                        break;
                        case 5:{
                            this.setFertilAnamnesResult('Пацієнтка планує народити дитину після терапії');
                        }
                        break;
                    }
                }
                else{
                    this.setFertilAnamnesResult('Кардіоміопатія після перенесеного міокардиту, порушення ритму, СН I');
                    this.setFertilAnamnesResult('Пацієнтка планує народити дитину після терапії');
                }
                
                // this.setFertilAnamnesResult('Пацієнтка планує народити дитину після терапії');
            }
            else{
                this.setFertilAnamnesResult('Пацієнтка планує народити дитину після терапії');
            }
        })
    }
}
</script>

<style lang="scss">
.anamnes{
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    .fertil-girl{
        .anamnes-with-by-effect{
             .by-effect{
                .by-effect-wrapper{  

                    .content{
                        .ill{
                            padding-bottom: 13px;
                            color: #575A5D;
                            font-style: normal;

                            .title{
                                text-align: left;
                                padding-bottom: 16px;
                                font-size: 16px;
                                line-height: 20px;
                                font-weight: 500;
                            }

                            p{
                                line-height: 24px;
                                font-size: 18px;
                                font-weight: 750;

                                padding-left: 0;
                                padding-right: 10%;
                            }
                        }

                        .baby{
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            // svg{
                            //     width: 80px;
                            //     min-width: 80px;
                            //     height: auto;
                            // }

                            p{
                                padding-left: 12px;

                                font-style: normal;
                                font-weight: 500;
                                font-size: 18px;
                                line-height: 24px;

                                color: #00607E;
                            }
                        }                       
                    }
                }
            }
        }

        .baby{
            .by-effect{
                .by-effect-wrapper{
                    .content{
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        // svg{
                        //     width: 80px;
                        // }

                        p{
                        padding-left: 12px;

                            font-style: normal;
                            font-weight: 500;
                            font-size: 18px;
                            line-height: 24px;

                            color: #00607E;
                        }
                    }
                }
            }
        }        
    }
}

@media (max-width: 599px){
    .anamnes{
        align-items: flex-start;
    }
}
</style>